
/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import dictionaryEn from 'theme/i18n/veeValidate.en'
import dictionaryIt from 'theme/i18n/veeValidate.it'
import validators from '@/helpers/validators'

// see it for more info
// @see https://vee-validate.logaretm.com/v2/guide/localization.html#vuei18n-integration
export default ({ appCreated }) => {
  appCreated(() => {
    Object.keys(validators).forEach(key => {
      Validator.extend(key, validators[key])
    })
    Vue.use(VeeValidate, {
      fieldsBagName: 'veeFields',
      inject: true,
      i18n: global.$i18n,
      dictionary: {
        en: dictionaryEn,
        it: dictionaryIt
      }
    })
  })
}
